export const BRANDS_URL = 'brands'